import type { FilterConfig } from '@/types/filters';
import { ALLOCATION_STATUS_METADATA } from '../constants/allocationStatus';
import { ALLOCATION_TYPE_METADATA, AllocationTypes } from '@/features/Collaborators/Models';

export const ALLOCATION_FILTER_CONFIGS: FilterConfig[] = [
    {
        columnId: 'allocationPreview.status',
        label: 'Status de Alocação',
        type: 'select',
        operators: ['equals', 'in', 'notIn'],
        options: Object.entries(ALLOCATION_STATUS_METADATA).map(([value, meta]) => ({
            value,
            label: meta.title,
        })),
        placeholder: 'Selecione o status de alocação...',
        category: 'Alocação',
    },
    {
        columnId: 'hasNotice',
        label: 'Aviso Prévio',
        type: 'boolean',
        operators: ['equals'],
        options: [
            { value: 'true', label: 'Sim' },
            { value: 'false', label: 'Não' },
        ],
        placeholder: 'Colaboradores em aviso prévio...',
        category: 'Alocação',
    },
    {
        columnId: 'allocationClientNames',
        label: 'Cliente da Alocação',
        type: 'multiselect',
        operators: ['in', 'notIn'],
        options: [],
        placeholder: 'Selecione o cliente...',
        category: 'Alocação',
    },
    {
        columnId: 'allocationActiveTypes',
        label: 'Tipo de Alocação',
        type: 'multiselect',
        operators: ['in', 'notIn'],
        options: Object.entries(ALLOCATION_TYPE_METADATA).map(([value, meta]) => ({
            value,
            label: meta.label,
        })),
        placeholder: 'Selecione o tipo de alocação...',
        category: 'Alocação',
    },
];

export const ALLOCATION_FIELD_ACCESSORS = {
    allocationClientNames: (item: any): string[] => {
        const clients = item.allocationSummary?.active?.map((entry: any) => entry.clientName).filter(Boolean) ?? [];
        return Array.from(new Set(clients));
    },
    allocationActiveTypes: (item: any): string[] => {
        const types = item.allocationSummary?.active?.map((entry: any) => entry.allocationType).filter(Boolean) ?? [];
        return Array.from(new Set(types));
    },
    hasNotice: (item: any): string => {
        if (typeof item.hasNotice === 'boolean') {
            return item.hasNotice ? 'true' : 'false';
        }

        const activeAllocations = item.allocationSummary?.active ?? [];
        const derived = activeAllocations.some((entry: any) => entry?.allocationType === AllocationTypes.Product);
        return derived ? 'true' : 'false';
    },
};
